<script>
import ConfirmWithdrawApplicationModal from './ConfirmWithdrawApplicationModal.vue'
import moment from "moment";

export default {
    components: { ConfirmWithdrawApplicationModal },
    props: {
        jobApplications: {
            type: Array,
            required: true,
        },
        csrfToken: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            open: true,
            currentJobApplicationId: null
        }
    },

    methods: {
        withdrawApplication (jobApplicationId){
            this.currentJobApplicationId = jobApplicationId
            this.$refs.confirmWithdrawApplicationModal.toggleModal()
        },
        isRequisitionActive(closingDate) {
            // Parse the closing date using moment
            const closingDateMoment = moment(closingDate);

            // Get today's date
            const today = moment().startOf('day'); // This sets the time to the start of the day

            // Compare the closing date with today's date
            return closingDateMoment.isSameOrAfter(today);
        }
    },
}
</script>

<template>
    <div class="job-application-accordion card">
        <div class="p-4">
            <div class="grid-x grid-padding-x grid-padding-y border-b">
                <div class="cell shrink">
                    <img src="/img/icons/id-card.svg" alt="Icon" />
                </div>

                <div class="cell auto">
                    <span class="text-site-gray f-15 bold">Job Applications <small class="minutes">({{ jobApplications.length }})</small></span>
                </div>

                <div class="cell shrink">
                    <a @click="open = !open">
                        <i class="fa" :class="open ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </a>
                </div>

                <div v-show="open" class="cell small-12">
                    <template>
                        <div v-for="jobApplication in jobApplications" :key="jobApplication.id" class="grid-x grid-padding-x job-application">
                            <div class="cell auto job-app-title">
                                {{ jobApplication.job.title }} (#{{ jobApplication.job.requisition_id }})

                                <template v-if="jobApplication.status">
                                    -
                                    <span class="job-application-status ml-4" :class="jobApplication.status">
                                        <strong v-if="jobApplication.status">
                                            Unsuccessful - 
                                        </strong>
                                    </span>
                                    <span v-if="jobApplication.fail_reason">
                                        {{ jobApplication.fail_reason }}
                                    </span>
                                </template>
                            </div>

                            <div class="cell shrink">
                                <span v-if="!jobApplication.status">
                                    Step - X
                                </span>

                                <a
                                    v-if="!['failed', 'recycled'].includes(jobApplication.status)"
                                    :href="`/candidate/job-applications/view/${jobApplication.id}`"
                                    class="button small continue"
                                >
                                    Continue
                                </a>
                                <a
                                    v-if="!['failed', 'recycled'].includes(jobApplication.status)"
                                    class="button small continue withdraw"
                                    @click="withdrawApplication(jobApplication.id)"
                                >
                                    Cancel
                                </a>

                                <a
                                    v-if="['failed'].includes(jobApplication.status) && jobApplication.is_reappliable && isRequisitionActive(jobApplication.job.requisition.closing_date)"
                                    :href="`/candidate/job-applications/reapply/${jobApplication.id}`"
                                    class="button small continue dark"
                                >
                                    Reapply
                                </a>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <confirm-withdraw-application-modal
            :job-application-id="currentJobApplicationId"
            :csrf-token="csrfToken"
            ref="confirmWithdrawApplicationModal"
        />
    </div>
</template>